import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { AppUtil } from '../../../utils/app.util';
import { AuthService } from 'src/app/services/core/auth.service';
import { AuthSession, decodeJWT } from '@aws-amplify/core';
import { AWSCredentials } from '@aws-amplify/core/internals/utils';
import { SsoType } from '../../shared/types';
import { Capacitor } from '@capacitor/core';

type IdpSsoAwsCredentials = AWSCredentials & { identityId?: string; expired?: boolean };

@Component({
	selector: 'app-sso-idp-initiated',
	templateUrl: './sso-idp-initiated.component.html',
	styleUrls: ['./sso-idp-initiated.component.scss'],
})
export class SsoIdpInitiatedComponent {
	/** Flag to check if device is mobile */
	isMobile = Capacitor.isNativePlatform();
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private spinner: SpinnerComponent,
		private authService: AuthService
	) {
		this.spinner.startLoader();
		this.getQueryParams();
	}

	getQueryParams() {
		if (AppUtil.isIE()) {
			try {
				let ssoRedirectUrl = localStorage.getItem('ssoRedirectUrl');
				ssoRedirectUrl = ssoRedirectUrl.split('?')[1];
				const searchParams = new URLSearchParams(ssoRedirectUrl);
				this.processTokens(searchParams.get('sso_token'), searchParams.get('jwt_token'));
			} catch (Exception) {
				this.spinner.stopLoader();
				console.error(
					`[${SsoIdpInitiatedComponent.name}][${this.getQueryParams.name}][1]`,
					'An error occurred while processing sso in IE : ',
					Exception
				);
				this.router.navigate(['sso/saml/sso-error'], { replaceUrl: true });
			}
		} else {
			this.route.queryParams.subscribe(data => {
				if (data) {
					this.processTokens(data.sso_token, data.jwt_token);
				} else {
					this.spinner.stopLoader();
					console.error(
						`[${SsoIdpInitiatedComponent.name}][${this.getQueryParams.name}][2]`,
						'An error occurred while processing sso - tokens not found'
					);
					this.router.navigate(['sso/saml/sso-error'], { replaceUrl: true });
				}
			});
		}
	}

	public async processTokens(idToken: string, jwtToken: string) {
		try {
			const authSession = SsoIdpInitiatedComponent.getAuthSession(idToken, jwtToken);
			await this.authService.updateAwsCredentialsForSsoIdp(authSession);
			this.router.navigate(['/dashboard'], { replaceUrl: true });
		} catch (error) {
			console.error(
				`[${SsoIdpInitiatedComponent.name}][${this.processTokens.name}]`,
				'An error occurred while decoding sso token',
				error
			);
			this.spinner.stopLoader();
			this.router.navigate(['sso/saml/sso-error'], { replaceUrl: true });
		}
	}

	public static getAuthSession(idToken: string, jwtToken: string) {
		let idpSsoAwsCredentials: IdpSsoAwsCredentials = JSON.parse(atob(idToken));
		idpSsoAwsCredentials.expiration = new Date(Date.parse('' + idpSsoAwsCredentials.expiration));
		const decodedJwtToken = decodeJWT(jwtToken);
		if (!idpSsoAwsCredentials.expired) {
			sessionStorage.setItem('auth', JSON.stringify({ idToken: { jwtToken: jwtToken, payload: decodedJwtToken } }));
			sessionStorage.setItem('sso', 'true');
			sessionStorage.setItem('sso-type', SsoType.IDPInitiated);
			sessionStorage.setItem('sso-tokens', JSON.stringify({ idToken, jwtToken }));

			const authSession: AuthSession = {
				credentials: idpSsoAwsCredentials,
				identityId: idpSsoAwsCredentials.identityId,
				tokens: {
					accessToken: decodedJwtToken,
					idToken: decodedJwtToken,
				},
				userSub: '',
			};
			return authSession;
		}
		throw Error('Token Expired');
	}
}
